window.__pf_unavailable_text = 'Nicht verfügbar';

document.querySelectorAll('.csr-text p').forEach(p => {
    const elements = [...p.children];

    // Nur <a> und <br> als direkte Elemente erlaubt
    if (elements.every(el => el.tagName === 'A' || el.tagName === 'BR')) {
        p.querySelectorAll('a').forEach(a => {
            a.classList.add('mr-button');
        });
        p.classList.add('mr-button-wrapper');

        p.querySelectorAll('br').forEach(br => {
            br.remove();
        });
    }
});

(function($) {

  $(document).ready(function() {
    $('.product-single-details .pf-slide-main-media img').each(function() {
      var that = $(this);
     that.magnify({
        src: that.attr('src')
      });
    });
  });


  $('*[data-action="url"]').on('click', function(e) {
    let that = $(this),
      url = that.data('href');
    console.log(window.Weglot);
    if (window.Weglot) {
        const currentLang = Weglot.getCurrentLang(); // z. B. 'en', 'fr', etc.
        

        if (url) {
          

          // 'de' ist die Default-Sprache → kein Sprachpräfix
          const localizedUrl = currentLang === 'de' 
            ? url 
            : `/${currentLang}${url}`;

          //defaultLink.setAttribute('href', localizedUrl);
          window.location = localizedUrl;
        }
  } else {
      window.location = url;
  }
  });
  
  $('a[href*="?page="]').each(function() {
    let that = $(this);
    that.on('click', function() {
      history.pushState({}, "", that.attr('href'));
    });
    //console.log();
  });
  
  if ($('#mr-related-products').find('.recommended-product').length === 0) {
    $('#mr-related-products').hide();
  }  

  if ($('#product-accordion').find('.product-accordion-toggle').length === 0) {
    $('#product-accordion').hide();
  }

  let productBoxes = $('div[data-product-id]');
  if (productBoxes.length) {
    productBoxes.each(function() {
      let that = $(this),
          dauertiefpreis = that.find('.dauertiefpreis');
      if (dauertiefpreis.length) {
        that.find('div[data-product-type="compare_at_price"]').hide();
        that.find('div[data-pf-type="Custom.HTML"]:contains(Sie sparen)').hide();
      } else {
        updateSavingInfo(that);
      }
    })
  }

  let variantOptions = $('.pf-option-swatches');
  if (variantOptions.length) {
    variantOptions.each(function() {
      let that = $(this),
        type = that.data('swatch-type'),
        productBox = that.closest('div[data-pf-type="ProductBox"]');
        switch(type) {
          case 'dropdown':
            that.find('.pf-variant-select').on('change', function(e) {
              updateSavingInfo(productBox)
            });
            break;
          case 'color':
            that.find('input').on('change', function(e) {
              updateSavingInfo(productBox)
            });
            break;
        }
    });
  }

  /*
  $('.pf-slide-list-media').on('click', function(e) {
    let that = $(this),
        mediaId = parseInt(that.data('img-id'));
    var sameImageForVariantsCount = 0;
    var mediaVariants = [];
    var availableOptions = [];
    productBox = that.closest('div[data-pf-type="ProductBox"]');
    if (typeof productOptions !== "undefined") {
        $.each(productOptions, function(index, option) {
          if (typeof option.featured_media !== "undefined" && option.featured_media.id === mediaId) {
   		  mediaVariants.push(option);
            sameImageForVariantsCount++;
            $.each(option.options, function(id, optValue) {
              availableOptions.push(optValue);
            });
          }
        });
        availableOptions = $.grep(availableOptions, function(el, index) {
            return index === $.inArray(el, availableOptions);
        });
        $.each(mediaVariants, function(index, option) {
          var returnEarly = false;
          //console.log(option);
          
          $.each(option.options, function(id, optValue) {
            //console.log(optValue);
            
            var selector = optValue.replace('ä', 'a').replace('ü', 'u').replace('ö', 'o').replace('|', '-').replace(/\//g, '-').replace(/\./g, '');
            var optInput = $('input[value="'+ selector + '"]');
            var currentOpt = $('input[name="' + optInput.attr('name') + '"]:checked');
              //console.log('input', optInput);
            
            if (optInput.length) {
              if (sameImageForVariantsCount === 1) {
                optInput.prop('checked', true).change().trigger("change");
              } else {
                if (optInput.parents('div[data-swatch-type="color"]').length) {
                  optInput.prop('checked', true).change().trigger("change");
                } else {
                  if ($.inArray(currentOpt.val(), availableOptions) ===  -1) {
                    optInput.prop('checked', true).change().trigger("change");
                      returnEarly = true; 
                  }
                }
              }
            } else {
              selector = selector.replace('-', ' ');
              optInput = $('option[value="'+ selector + '"]');
              //console.log('select', optInput);
              if (optInput.length) {
                if (sameImageForVariantsCount === 1) {
                  optInput.closest('select').val(optInput.attr('value')).trigger("change");

                } else {
                    if ($.inArray(currentOpt.val(), availableOptions) ===  -1) {
                        optInput.closest('select').val(optInput.attr('value')).trigger("change");
                        returnEarly = true; 
                    }
                }
                returnEarly = true; 
              }
            }
          });
          if (returnEarly) {
            //updateSavingInfo(productBox);
           	return false; 
          }
        }); 
      //updateSavingInfo(productBox);
    }
  });
  */

    $('.pf-slide-list-media').on('click', function(e) {
      if (typeof productOptions !== "undefined") {
        console.log('Product Variants', productOptions);
        var that = $(this),
            productBox = that.closest('div[data-pf-type="ProductBox"]'),
            mediaId = parseInt(that.data('img-id')),
            mediaVariants = productOptions.filter((prodVariant) => prodVariant.featured_media.id === mediaId),
            optionSwatches = productBox.find('.pf-option-swatches'),
            variantInput = productBox.find('input[name="id"]'),
            priceContainer = productBox.find('div[data-product-type="price"]'),
            compareAtContainer = productBox.find('div[data-product-type="compare_at_price"]')

        //console.log('Media Id', mediaId);
        //console.log('Media Variants', mediaVariants);

        if (mediaVariants.length) {
          let newVariant = mediaVariants[0];
          optionSwatches.each(function() {
            let swatch = $(this),
                type = swatch.data('swatch-type');
            $.each(newVariant.options, function(index, option) {
              switch (type) {
                case 'dropdown':
                  var selectOption = swatch.find('option[value="' + option + '"]');
                  if (selectOption.length) {
                    swatch.find('select').val(option).change();
                  }
                  break;
                default:
                  var inputOption = swatch.find('input[value="' + option + '"]');
                  if (inputOption.length) {
                    inputOption.prop('checked', true).change();
                  }
                  break;
              }
            });
          });
          priceContainer.text(formatMoney(newVariant.price, false));
          if (newVariant.compare_at_price) {
            compareAtContainer.text(formatMoney(newVariant.compare_at_price, false));            
          }
          variantInput.val(newVariant.id);
          
          const url = new URL(window.location)
          url.searchParams.set("variant", newVariant.id)
          history.replaceState(null, '', url);
          updateSavingInfo(productBox);
        }
      }
    });

function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || "€ {{amount}}";

    function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || '.';
        decimal = decimal || ',';

        if (isNaN(number) || number == null) return 0;

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            '$1' + thousands
        );
        var centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
}

function parsePriceToCents(input) {
  if (!input || typeof input !== "string") return null;

  // 1) nur relevante Zeichen behalten (Zahlen, Punkt, Komma)
  let cleaned = input.replace(/[^0-9.,]/g, "");

  if (!cleaned) return null;

  // 2) Wenn sowohl Punkt als auch Komma vorkommen:
  //    -> der letzte Trenner ist das Dezimalzeichen
  const lastComma = cleaned.lastIndexOf(",");
  const lastDot = cleaned.lastIndexOf(".");

  let decimalSeparator = null;

  if (lastComma !== -1 && lastDot !== -1) {
    decimalSeparator = lastComma > lastDot ? "," : ".";
  } else if (lastComma !== -1) {
    decimalSeparator = ",";
  } else if (lastDot !== -1) {
    decimalSeparator = ".";
  }

  // 3) Tausendertrenner entfernen, Dezimaltrenner normalisieren
  if (decimalSeparator === ",") {
    cleaned = cleaned.replace(/\./g, ""); // Punkte sind Tausender
    cleaned = cleaned.replace(",", ".");
  } else if (decimalSeparator === ".") {
    cleaned = cleaned.replace(/,/g, ""); // Kommas sind Tausender
  }

  // 4) in float umwandeln
  const value = parseFloat(cleaned);

  if (isNaN(value)) return null;

  // 5) in Cent
  return Math.round(value * 100);
}

  function updateSavingInfo(productBox) {
    setTimeout(function() {
          let priceContainer = productBox.find('div[data-product-type="price"]'),
            compareAtContainer = productBox.find('div[data-product-type="compare_at_price"]');
          //console.log('compare container', compareAtContainer.text().trim());
          let variantId = productBox.find('input[data-product-id]').val();
          var delivery_note = $('<div class="variant-delivery-note" style="display: none;"></div>');
          if (typeof variantId !== 'undefined') {
            //console.log(window.variants_with_shipping_note);
            //console.log(window.variant_shipping_note);
            //console.log('var id', variantId);
            if ($('.variant-delivery-note').length === 0) {
              delivery_note.insertBefore($('button.lb-cart-drawer-opener'));
            }
            
            if (typeof window.variant_shipping_note !== 'undefined' && window.variant_shipping_note !== '' && window.variants_with_shipping_note.length && ($.inArray(variantId, window.variants_with_shipping_note) !== -1 )) {
              $('.variant-delivery-note').html(window.variant_shipping_note).show();
            } else {
              $('.variant-delivery-note').hide();
            }
            //console.log(window.variants_with_shipping_note.length);
            //console.log($.inArray(variantId, window.variants_with_shipping_note));
            //console.log(delivery_note);
          }

          
          
      
          if (compareAtContainer.length && compareAtContainer.text().trim() !== "") {
            $.each(__pageflyProducts[productBox.data('product-id')].variants, function(k,v) {
              //console.log(v.id);
              //console.log(variantId);
              if (v.id === parseInt(variantId)) {
                //console.log('if id compare', v.compare_at_price);
                //console.log('if id preis', v.price);
                let savings = (v.compare_at_price - v.price) / 100;
                //console.log(savings);
                const nFormat = new Intl.NumberFormat('de-DE');
                //console.log(nFormat.format(savings));
                dauertiefpreis = productBox.find('.dauertiefpreis');
                if (dauertiefpreis.length === 0) {
                  productBox.find('div[data-pf-type="Custom.HTML"]:contains(Sie sparen)').show().text('Sie sparen € ' + nFormat.format(savings));
                }
              }
            });
            //console.log(variantId);
          } else {
            productBox.find('div[data-pf-type="Custom.HTML"]:contains(Sie sparen)').hide();
            let listProductPriceContainer = productBox.find('.product-price');
            if (listProductPriceContainer.length) {
              currentlyShownPrice = parsePriceToCents(listProductPriceContainer.text());
              //console.log('current price', currentlyShownPrice);
              $.each(__pageflyProducts[productBox.data('product-id')].variants, function(k,v) {
                if (v.id === parseInt(variantId)) {
                    console.log(v);
                    //console.log('if id compare', v.compare_at_price);
                    //console.log('if id preis', v.price);
                    if (currentlyShownPrice !== v.price) {
                      if (v.compare_at_price > v.price) {
                        listProductPriceContainer.find('.product__price-price .money').text( formatMoney(v.price));
                        listProductPriceContainer.find('.product__price-cross .money').text( formatMoney(v.compare_at_price));
                      } else {
                        
                          listProductPriceContainer.find('.product__price-price .money').text( formatMoney(v.price));
                          listProductPriceContainer.find('.product__price-cross').hide();
                        
                      }
                    }
                }
              });
            }
          }
    }, 0);
  }

  if ($('.product-certificate img').length) {
    $('.product-certificate img').on('click', function() {
      let that = $(this),
          link = that.data('link');
      if (link !== '') {
        window.open(link, "_blank");
      }
    });
  }

  if ($('#product-list').length) {
    $('#product-list div[data-product-id]').each(function() {
      let max_swatches = 5;
      let product = $(this),
          more_swatches = false,
          swatch_class = '';
      product.find('.pf-vs-color, .pf-vs-image').each(function(index) {
        let swatch = $(this),
            is_color = swatch.hasClass('pf-vs-color');
        max_swatches = is_color ? 5 : 3;
        if ($( window ).width() <= 768) {
          max_swatches = max_swatches-1;
        }
        swatch_class = is_color ? 'pf-vs-color' : 'pf-vs-image';
        if (index >= (max_swatches-1) ) {
          swatch.hide();
          more_swatches = true;
        }
      });
      if (more_swatches && product.find('.more-available').length === 0) {
        let more_swatches_button = $('<span class="more-available">+' + product.find('.' + swatch_class + ':hidden').length + '</span>');
        more_swatches_button.insertAfter(product.find('.' + swatch_class).last());
        more_swatches_button.on('click', function() {
          if (product.find('*[data-product-type="title"]').length) {
            window.location = product.find('*[data-product-type="title"]').data('href');
          } else {
            window.location = product.find('.product-list-title').attr('href');
          }
          
        });
      }
    });
    let pagination = $('#product-list button.pf-slider-prev').prev('div');
    if (pagination.children().length <= 1) {
      pagination.hide();
    }

    function setWidth() {
    	$(".selector-wrapper").each(function(i) {
    	  var labelWidth = $(this)
    		.find("label")
    		.width();
    	  $(this)
    		.find("select")
    		.css("padding-left", 20 + labelWidth);
    	});
    }
    setWidth();
    setTimeout(setWidth, 500);//repeat
    setTimeout(setWidth, 2000);//repeat 

      var filterWrappers = $('.dropdown-filter-wrapper .selector-wrapper');
      filterWrappers.each(function() {
      	var that = $(this);
        that.on('click', function() {
          if (that.hasClass('open')) {
            that.removeClass('open');
          } else {
            that.addClass('open');
            filterWrappers.not(that).removeClass('open');
          };
        });
      });

    function collectionSort() {
  Shopify.queryParams = {};
  if (location.search.length) {
	for (
	  var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&");
	  i < aCouples.length;
	  i++
	) {
	  aKeyValue = aCouples[i].split("=");
	  if (aKeyValue.length > 1) {
		Shopify.queryParams[
		  decodeURIComponent(aKeyValue[0])
		] = decodeURIComponent(aKeyValue[1]);
	  }
	}
  }

  var defaultSort = $(".filter-sort-wrapper").data("default-sort");
  $("#SortBy")
	.val(defaultSort)
	.bind("change", function() {
	  Shopify.queryParams.sort_by = jQuery(this).val();
	  location.search = jQuery.param(Shopify.queryParams);
	});
};
    collectionSort();

    
  }

  let accordeon = $('#product-accordion div[data-pf-type="Accordion.Content.Wrapper"]');
  accordeon.each(function() {
    let that = $(this);
    if (that.find('.metafield-rich_text_field').text().trim() === "") {
      that.hide();
    }
  });
})(jQuery);

